import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { EventSliderCardCss } from "./EventSliderCardCss";
import { Col, Row, Image, Button } from "react-bootstrap";
import "./EventSliderCard.css";
import { Link, useNavigate } from "react-router-dom";

interface EventSliderCardI {
  title: string;
  league: string;
  imageUrl: string;
  event: boolean;
  buttonText: string;
  teams?: any[];
  date?: string;
  sport?: string;
  competitionLogo?: string;
  uuid?: string;
  url?: string;
}

const EventSliderCard = (card: EventSliderCardI) => {
  const navigate = useNavigate();
  const [isHovered, setHovered] = useState(false);
  const teams = card?.teams ?? [];

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const cardContentSlider = {
    ...EventSliderCardCss.eventContent,
    opacity: isHovered ? 1 : 0
  };

  return (
    <div
      className="event-wrap-plr slick-slide slick-active active"
      style={EventSliderCardCss.eventWrapMain}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className="event-wrap text-center"
        style={EventSliderCardCss.eventWrap}
      >
        <div
          className="event-img"
          style={{
            background: `url(/${card?.sport}.png)`,
            ...EventSliderCardCss.eventImage
          }}
        >
          <Link
            to={`${card?.url}`}
            tabIndex={0}
            className="main-link"
            style={{
              textDecoration: "none",
              display: "block",
              marginLeft: "7px",
              marginRight: "7px"
            }}
          >
            {card.event ? (
              <Row>
                <Col
                  lg={12}
                  style={{ paddingTop: "6px", paddingBottom: "6px" }}
                >
                  <Image
                    src={card?.competitionLogo ?? "/default-team-logo.svg"}
                    style={{ display: "inline", objectFit: "contain" }}
                    width={"20px"}
                    height={"20px"}
                    onError={(e) => {
                      e.currentTarget.src = "/default-team-logo.svg";
                    }}
                  />
                  <span
                    style={{
                      fontSize: "10px",
                      color: "#fff",
                      textTransform: "uppercase",
                      fontWeight: "bold"
                    }}
                  >
                    {" "}
                    {card?.league?.length <= 17
                      ? card?.league
                      : `${card?.league.slice(0, 16)}...`}
                  </span>
                </Col>

                <Col
                  lg={5}
                  md={5}
                  xs={5}
                  sm={5}
                  style={{ ...EventSliderCardCss.teamSlider }}
                >
                  <Image
                    alt="St. Louis Sting 15U AA"
                    src={teams[0]?.images[0]?.url ?? "/default-team-logo.svg"}
                    decoding="async"
                    data-nimg="fixed"
                    className="teamLogo"
                    style={EventSliderCardCss.teamSlideImage}
                    onError={(e) => {
                      e.currentTarget.src = "/default-team-logo.svg";
                    }}
                  />
                  <div>
                    <h6
                      className="teamName"
                      style={{ fontSize: "10px", color: "#fff" }}
                    >
                      {teams[0]?.name ?? "Team One"}
                    </h6>
                  </div>
                </Col>

                <Col
                  lg={2}
                  md={2}
                  xs={2}
                  sm={2}
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    color: "#fff",
                    fontWeight: "400",
                    fontSize: "1.5vw"
                  }}
                >
                  VS.
                </Col>

                <Col
                  lg={5}
                  md={5}
                  xs={5}
                  sm={5}
                  style={{ ...EventSliderCardCss.teamSlider }}
                >
                  <Image
                    alt="St. Louis Sting 15U AA"
                    src={teams[1]?.images[0]?.url ?? "/default-team-logo.svg"}
                    decoding="async"
                    data-nimg="fixed"
                    className="teamLogo"
                    style={{
                      ...EventSliderCardCss.teamSlideImage
                    }}
                    onError={(e) => {
                      e.currentTarget.src = "/default-team-logo.svg";
                    }}
                  />
                  <div>
                    <h6
                      className="teamName"
                      style={{ fontSize: "10px", color: "#fff" }}
                    >
                      {teams[1]?.name ?? "Team Two"}
                    </h6>
                  </div>
                </Col>
              </Row>
            ) : (
              <Image
                src={card.imageUrl}
                width={"100%"}
                style={EventSliderCardCss.img}
              />
            )}
          </Link>
        </div>
        <div
          className="event-content"
          style={{
            ...cardContentSlider,
            marginLeft: !card.event ? "7px" : "0px",
            marginRight: !card.event ? "7px" : "0px"
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: "0px",
              width: "100%",
              padding: "10px"
            }}
          >
            {card.event ? (
              <>
                <Button
                  className="landing-btn-style"
                  style={EventSliderCardCss.watchNowBtn}
                  onClick={() => navigate(`/events/${card.uuid}`)}
                >
                  Watch Now
                </Button>
              </>
            ) : (
              <div style={{ color: "#fff" }}>
                <h3 className="title">
                  <Link
                    to={`${card?.url}`}
                    style={EventSliderCardCss.eventTitle}
                    tabIndex={0}
                  >
                    {card.title}
                  </Link>
                </h3>
                <>
                  <Button
                    className="landing-btn-style"
                    style={EventSliderCardCss.watchNowBtn}
                    onClick={() => navigate(`${card?.url}`)}
                  >
                    {card?.buttonText}
                  </Button>
                </>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventSliderCard;
